export enum ECategoryType {
  SALES_CC = 'company_email_cc_sales',
  SALES_BCC = 'company_email_bcc_sales',
  GENERAL_CC = 'company_email_cc_general',
  GENERAL_BCC = 'company_email_bcc_general'
}
